// eslint-disable-next-line import/prefer-default-export
export const ROBOHASH_PROFILE_PIC = "https://robohash.org";
export const MAX_IMAGE_WIDTH = 694;
export const MAX_IMAGE_HEIGHT = 800;
export const INITIAL_IMAGE_WIDTH = 300;
export const INITIAL_IMAGE_HEIGHT = 250;
export const MIN_IMAGE_WIDTH = 21;
export const MIN_IMAGE_HEIGHT = 21;
export const INITIAL_ESIGN_WIDTH = 200;
export const INITIAL_ESIGN_HEIGHT = 60;
export const INITIAL_ESIGN_WIDTH_CHECKBOX = 20;
export const INITIAL_ESIGN_HEIGHT_CHECKBOX = 20;
export const MAX_ESIGN_WIDTH = 612;
export const MAX_ESIGN_HEIGHT = 400;
export const MIN_ESIGN_WIDTH = 74;
export const MIN_ESIGN_HEIGHT = 24;

// S3 bucket image paths
const IMAGE_S3_BASE_PATH =
  "https://d34fwl795uvawg.cloudfront.net/images/reactgrid";
const IMAGE_S3_BASE_PATH_LZ =
  "https://d34fwl795uvawg.cloudfront.net/images/legalzoom";
const IMAGE_S3_BASE_PATH_LZ_TEST =
  "https://d34fwl795uvawg.cloudfront.net/preprod-images/legalzoom";

// .svg files
export const UNSPLASH_LOGO = `${IMAGE_S3_BASE_PATH}/Unsplash_Symbol.svg`;
export const OFFER_ARROW = `${IMAGE_S3_BASE_PATH}/seeallplans-arrow.svg`;
export const DOCUMENT_ICO = `${IMAGE_S3_BASE_PATH}/document-icons/ic-file-revv.svg`;
export const FOLDER_ICO = `${IMAGE_S3_BASE_PATH}/document-icons/ic-revv-folder.svg`;
export const LINKED_FOLDER_ICO = `${IMAGE_S3_BASE_PATH}/document-icons/ic-linked-folder.svg`;
export const PDF_ICO = `${IMAGE_S3_BASE_PATH}/document-icons/ic-file-pdf.svg`;
export const STAR = `${IMAGE_S3_BASE_PATH}/upgrade-star.svg`;
export const PDF = `${IMAGE_S3_BASE_PATH}/attachment-icons/pdf.svg`;
export const PNG = `${IMAGE_S3_BASE_PATH}/attachment-icons/png.svg`;
export const JPG = `${IMAGE_S3_BASE_PATH}/attachment-icons/jpg.svg`;
export const JPEG = `${IMAGE_S3_BASE_PATH}/attachment-icons/Jpeg.svg`;
export const DOC = `${IMAGE_S3_BASE_PATH}/attachment-icons/doc.svg`;
export const DOCX = `${IMAGE_S3_BASE_PATH}/attachment-icons/docx.svg`;
export const JSONFILE = `${IMAGE_S3_BASE_PATH}/attachment-icons/json.svg`;
export const XLS = `${IMAGE_S3_BASE_PATH}/attachment-icons/xls.svg`;
export const XLSM = `${IMAGE_S3_BASE_PATH}/attachment-icons/xlsm.svg`;
export const XML = `${IMAGE_S3_BASE_PATH}/attachment-icons/xml.svg`;
export const AVI = `${IMAGE_S3_BASE_PATH}/attachment-icons/avi.svg`;
export const CSV = `${IMAGE_S3_BASE_PATH}/attachment-icons/csv.svg`;
export const GIF = `${IMAGE_S3_BASE_PATH}/attachment-icons/GIF.svg`;
export const MOV = `${IMAGE_S3_BASE_PATH}/attachment-icons/MOV.svg`;
export const WEBM = `${IMAGE_S3_BASE_PATH}/attachment-icons/WEBM.svg`;
export const M4V = `${IMAGE_S3_BASE_PATH}/attachment-icons/M4V.svg`;
export const MID = `${IMAGE_S3_BASE_PATH}/attachment-icons/mid.svg`;
export const SVG = `${IMAGE_S3_BASE_PATH}/attachment-icons/svg.svg`;
export const XLSX = `${IMAGE_S3_BASE_PATH}/attachment-icons/Xlsx.svg`;
export const PPT = `${IMAGE_S3_BASE_PATH}/attachment-icons/ppt.svg`;
export const PPTX = `${IMAGE_S3_BASE_PATH}/attachment-icons/PPTX.svg`;
export const MP4 = `${IMAGE_S3_BASE_PATH}/attachment-icons/mp4.svg`;
export const WAV = `${IMAGE_S3_BASE_PATH}/attachment-icons/wav.svg`;
export const TXT = `${IMAGE_S3_BASE_PATH}/attachment-icons/txt.svg`;
export const MP3 = `${IMAGE_S3_BASE_PATH}/attachment-icons/mp3.svg`;
export const OGG = `${IMAGE_S3_BASE_PATH}/attachment-icons/ogg.svg`;
export const MKV = `${IMAGE_S3_BASE_PATH}/attachment-icons/mkv.svg`;
export const FLAC = `${IMAGE_S3_BASE_PATH}/attachment-icons/Flac.svg`;
export const AAC = `${IMAGE_S3_BASE_PATH}/attachment-icons/AAC.svg`;
export const GP = `${IMAGE_S3_BASE_PATH}/attachment-icons/3GP.svg`;
export const AMR = `${IMAGE_S3_BASE_PATH}/attachment-icons/AMR.svg`;
export const M4A = `${IMAGE_S3_BASE_PATH}/attachment-icons/m4a.svg`;
export const FLV = `${IMAGE_S3_BASE_PATH}/attachment-icons/FLV.svg`;
export const APPROVE = `${IMAGE_S3_BASE_PATH}/Approved.svg`;
export const ACCEPTED = `${IMAGE_S3_BASE_PATH}/Accepted.svg`;
export const ESIGNED = `${IMAGE_S3_BASE_PATH}/eSigned.svg`;
export const QUO = `${IMAGE_S3_BASE_PATH}/ic-QUO.svg`;
export const MSA = `${IMAGE_S3_BASE_PATH}/ic-MSA.svg`;
export const SOW = `${IMAGE_S3_BASE_PATH}/ic-SOW.svg`;
export const SLA = `${IMAGE_S3_BASE_PATH}/ic-SLA.svg`;
export const NDA = `${IMAGE_S3_BASE_PATH}/ic-NDA.svg`;
export const CSA = `${IMAGE_S3_BASE_PATH}/ic-CSA.svg`;
export const SAQ = `${IMAGE_S3_BASE_PATH}/ic-SAQ.svg`;
export const DPA = `${IMAGE_S3_BASE_PATH}/ic-DPA.svg`;
export const SHIELD = `${IMAGE_S3_BASE_PATH}/ic-shield.svg`;
export const VIDEO_ICO = `${IMAGE_S3_BASE_PATH}/document-icons/video-icon.svg`;
export const PAID = `${IMAGE_S3_BASE_PATH}/Paid.svg`;
export const LOGOSTRIPE = `${IMAGE_S3_BASE_PATH}/certificate-logos/stripe-logo.svg`;
export const ADD_USER = `${IMAGE_S3_BASE_PATH}/navbar/add-user-selected.svg`;
export const UPLOAD_FORMAT_IMG = `${IMAGE_S3_BASE_PATH}/upload-format.svg`;
export const TableAddColumnRight = `${IMAGE_S3_BASE_PATH}/table-icons/ic-column-add.svg`;
export const TableAddColumnLeft = `${IMAGE_S3_BASE_PATH}/table-icons/ic-column-add-left.svg`;
export const TableRemoveColumn = `${IMAGE_S3_BASE_PATH}/table-icons/ic-column-remove.svg`;
export const TableAddRowBelow = `${IMAGE_S3_BASE_PATH}/table-icons/ic-row-add.svg`;
export const TableAddRowAbove = `${IMAGE_S3_BASE_PATH}/table-icons/ic-row-add-up.svg`;
export const TableRemoveRow = `${IMAGE_S3_BASE_PATH}/table-icons/ic-row-delete.svg`;
export const TableBorder = `${IMAGE_S3_BASE_PATH}/table-icons/ic-border-color.svg`;
export const UnmergeImg = `${IMAGE_S3_BASE_PATH}/table-icons/ic-unmerge.svg`;
export const MergeImg = `${IMAGE_S3_BASE_PATH}/table-icons/ic-merge.svg`;
export const DisabledImg = `${IMAGE_S3_BASE_PATH}/table-icons/ic-merge-disabled.svg`;
export const oauthEmptyScreen = `${IMAGE_S3_BASE_PATH}/oauth-empty-screen.svg`;
export const TEMPLATE_ICO = `${IMAGE_S3_BASE_PATH}/document-icons/ic-file-template.svg`;
//
export const AddUser = `${IMAGE_S3_BASE_PATH}/lz-navbar/add-user.svg`;
export const AddUserSeleted = `${IMAGE_S3_BASE_PATH}/lz-navbar/add-user-selected.svg`;
export const Documents = `${IMAGE_S3_BASE_PATH}/lz-navbar/documents.svg`;
export const DocumentsSelected = `${IMAGE_S3_BASE_PATH}/lz-navbar/documents-selected.svg`;
export const Pipeline = `${IMAGE_S3_BASE_PATH}/lz-navbar/pipeline.svg`;
export const PipelineSelected = `${IMAGE_S3_BASE_PATH}/lz-navbar/pipeline-selected.svg`;
export const Pricebooks = `${IMAGE_S3_BASE_PATH}/lz-navbar/pricebooks.svg`;
export const PricebooksSelected = `${IMAGE_S3_BASE_PATH}/lz-navbar/pricebooks-selected.svg`;
export const Products = `${IMAGE_S3_BASE_PATH}/lz-navbar/products.svg`;
export const ProductsSelected = `${IMAGE_S3_BASE_PATH}/lz-navbar/products-selected.svg`;
export const Settings = `${IMAGE_S3_BASE_PATH}/lz-navbar/settings.svg`;
export const SettingsSelected = `${IMAGE_S3_BASE_PATH}/lz-navbar/settings-selected.svg`;
export const Templates = `${IMAGE_S3_BASE_PATH}/lz-navbar/templates.svg`;
export const TemplatesSelected = `${IMAGE_S3_BASE_PATH}/lz-navbar/templates-selected.svg`;
export const Workflow = `${IMAGE_S3_BASE_PATH}/lz-navbar/workflow.svg`;
export const WorkflowSelected = `${IMAGE_S3_BASE_PATH}/lz-navbar/workflow-selected.svg`;
export const Shield = `${IMAGE_S3_BASE_PATH}/navbar/shield.svg`;
export const OH_SNAP = `${IMAGE_S3_BASE_PATH}/oh-snap.svg`;

// .png files
export const documentSentConfirmation = `${IMAGE_S3_BASE_PATH}/document-sent-confirmation.png`;
export const AssetsOppEmptyImageSrc = `${IMAGE_S3_BASE_PATH}/No-opportunity.png`;
export const EMPTY_PAGE_ICO = `${IMAGE_S3_BASE_PATH}/empty-State-v5.png`;
export const UPLOAD_IMG = `${IMAGE_S3_BASE_PATH}/attachment-icons/grouped_attachment.png`;
export const NO_QUOTES = `${IMAGE_S3_BASE_PATH}/quotes_empty_state.png`;
export const TemplateEmptyImageSrc = `${IMAGE_S3_BASE_PATH}/Select-account.png`;
export const EmptyStateDynamicFeild = `${IMAGE_S3_BASE_PATH}/empty-state-graphic.png`;
export const cameraBlock = `${IMAGE_S3_BASE_PATH}/Camera-block-img-3c.png`;
export const AcceptanceGraphic = `${IMAGE_S3_BASE_PATH}/Acceptance-Graphic.png`;
export const DECLINE = `${IMAGE_S3_BASE_PATH}/Declined.png`;
export const REJECTED = `${IMAGE_S3_BASE_PATH}/Badge-Rejected.png`;
export const RECIPIENT_ACCEPT = `${IMAGE_S3_BASE_PATH}/recipient_accept.png`;
export const RECIPIENT_DECLINE = `${IMAGE_S3_BASE_PATH}/recipient_reject_decline.png`;
export const RECIPIENT_DECLINE_LZ = `${IMAGE_S3_BASE_PATH_LZ}/recipient-reject-decline.png`;
export const RECIPIENT_THANKS = `${IMAGE_S3_BASE_PATH}/recipient_thanks.png`;
export const RECIPIENT_VIDEO_KYC = `${IMAGE_S3_BASE_PATH}/recipient_video-KYC.png`;
export const RECIPIENT_SUBMIT = `${IMAGE_S3_BASE_PATH}/recipient_submit.png`;
export const RECIPIENT_EMPTY_FIELDS = `${IMAGE_S3_BASE_PATH}/recipient_empty_fields.png`;
export const STRIPE_LOGO = `${IMAGE_S3_BASE_PATH}/logo-stripe.png`;
export const NO_BACKGROUND_IMAGE = `${IMAGE_S3_BASE_PATH}/No-bg-image.png`;
export const errorImage = `${IMAGE_S3_BASE_PATH}/image-onerror.png`;
export const emptyCoverpageHeaderFooterPlaceholder = `${IMAGE_S3_BASE_PATH}/blank-coverpage-headerfooter-default.png`;
export const addDynamicFeild = `${IMAGE_S3_BASE_PATH}/add-dynamic-field.png`;
export const noFields = `${IMAGE_S3_BASE_PATH}/empty state image for form window.png`;
export const CHAT_PERSON_IMAGE = `${IMAGE_S3_BASE_PATH}/drift-chat-image.png`;
export const fourofour = `${IMAGE_S3_BASE_PATH}/fourofour.png`;
export const ESIGN_EXPIRED = `${IMAGE_S3_BASE_PATH}/esign-expired.png`;
export const spreadsheetIcon = `${IMAGE_S3_BASE_PATH}/spreadsheet-icon.png`;
export const G_SHEET = `${IMAGE_S3_BASE_PATH}/g-sheet-icon.png`;
export const NO_SHEETS = `${IMAGE_S3_BASE_PATH}/Sheets-to-Revv.png`;
export const DELETED_SHEETS = `${IMAGE_S3_BASE_PATH}/Deleted-Sheet.png`;
export const logoESIGN = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-esign.png`;
export const logoUETA = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-UETA.png`;
export const logoEIDAS = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-eiDAS.png`;
export const logoAWS = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-aws.png`;
export const logoOneSpan = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-onespan.png`;
export const LANE_JTBD = `${IMAGE_S3_BASE_PATH}/Lane-JTBD-Coming-soon.png`;
export const REMINDER_JTBD = `${IMAGE_S3_BASE_PATH}/Lane-JTBD.png`;
export const SLACK_LOGO = `${IMAGE_S3_BASE_PATH}/logo-slack.png`;
export const emptyImage = `${IMAGE_S3_BASE_PATH}/empty-meta-tags.png`;
export const APPROVE_PNG = `${IMAGE_S3_BASE_PATH}/Approve-Icon.png`;
export const SIGNATURE = `${IMAGE_S3_BASE_PATH}/Signature-icon.png`;
export const ESIGN_TOOLTIP_PNG = `${IMAGE_S3_BASE_PATH}/TT-Send-for-eSign.png`;
export const SEND_TO_SOMEONE_PNG = `${IMAGE_S3_BASE_PATH}/TT-Send-to-somone.png`;
export const SEND_FOR_ACCEPTANCE = `${IMAGE_S3_BASE_PATH}/TT-Send-for-Acceptance.png`;
export const SEND_FOR_PAYMENT_PNG = `${IMAGE_S3_BASE_PATH}/TT-Send-for-Payment.png`;
export const SEND_FOR_APPROVAL_PNG = `${IMAGE_S3_BASE_PATH}/TT-Send-for-Approval.png`;
export const MASTER_DOCUMENT_FORM_FILL_IMG = `${IMAGE_S3_BASE_PATH}/TT_web-form-link.png`;
export const MAGICLINK_PNG = `${IMAGE_S3_BASE_PATH}/TT-Magic-Link.png`;
export const SNAPLINK_PNG = `${IMAGE_S3_BASE_PATH}/TT-Snaplink.png`;
export const awesomWebformLink = `${IMAGE_S3_BASE_PATH}/Awesome-Webform-Link@2x.png`;
export const ESIGNED2 = `${IMAGE_S3_BASE_PATH}/eSigned-2.png`;
export const REFERRALIMAGE = `${IMAGE_S3_BASE_PATH}/referral-img.png`;
export const AVATOR = `${IMAGE_S3_BASE_PATH}/rep_dp.png`;
export const formSubmissionThankyou = `${IMAGE_S3_BASE_PATH}/form-submission-Success.png`;
export const WF_EMPTY_SCREEN_IMG_SRC = `${IMAGE_S3_BASE_PATH}/workflow-empty.png`;
export const upgradeWorkflowimg = `${IMAGE_S3_BASE_PATH}/featureGatingImages/upgrade-workflows.png`;
export const upgradeAddtoclauseimg = `${IMAGE_S3_BASE_PATH}/featureGatingImages/upgrade-add-to-clause.png`;
export const upgradePricebooksimg = `${IMAGE_S3_BASE_PATH}/featureGatingImages/upgrade-add-pricebooks.png`;
export const upgradePricebooksUpdateimg = `${IMAGE_S3_BASE_PATH}/featureGatingImages/upgrade-pricebook-update.png`;
export const codeconstructionlogo = `${IMAGE_S3_BASE_PATH}/billing-icons/code-construction-logo.png`;
export const industryconnectlogo = `${IMAGE_S3_BASE_PATH}/billing-icons/industry-conect-logo.png`;
export const microniclogo = `${IMAGE_S3_BASE_PATH}/billing-icons/micronic-logo.png`;
export const moglixlogo = `${IMAGE_S3_BASE_PATH}/billing-icons/moglix-logo.png`;
export const sproutsolutionlogo = `${IMAGE_S3_BASE_PATH}/billing-icons/sprout-solution-logo.png`;
export const tagnos = `${IMAGE_S3_BASE_PATH}/billing-icons/tagnos.png`;
export const ADP_LOGO = `${IMAGE_S3_BASE_PATH}/logo-adp.png`;
export const BAMBOO_LOGO = `${IMAGE_S3_BASE_PATH}/logo-bamboo.png`;
export const BIGIN_LOGO = `${IMAGE_S3_BASE_PATH}/logo-bigin.png`;
export const BRAINTREE_LOGO = `${IMAGE_S3_BASE_PATH}/logo-braintree.png`;
export const DOCSIGN_LOGO = `${IMAGE_S3_BASE_PATH}/logo_docsign.png`;
export const FRESHBOOKS_LOGO = `${IMAGE_S3_BASE_PATH}/logo-freshbooks.png`;
export const FRESHSALES_LOGO = `${IMAGE_S3_BASE_PATH}/logo-freshsales.png`;
export const HUBSPOT_LOGO = `${IMAGE_S3_BASE_PATH}/logo-hubspot.png`;
export const NAMELY_LOGO = `${IMAGE_S3_BASE_PATH}/logo-namely.png`;
export const NETSUITE_LOGO = `${IMAGE_S3_BASE_PATH}/logo-netsuite.png`;
export const PIPEDRIVE_LOGO = `${IMAGE_S3_BASE_PATH}/logo-pipedrive.png`;
export const QUICKBOOK_LOGO = `${IMAGE_S3_BASE_PATH}/logo-quickbook.png`;
export const SAGEINTACCT_LOGO = `${IMAGE_S3_BASE_PATH}/logo-sage-intacct.png`;
export const SF_LOGO = `${IMAGE_S3_BASE_PATH}/logo-sf.png`;
export const XERO_LOGO = `${IMAGE_S3_BASE_PATH}/logo-xero.png`;
export const ZAPIER_LOGO = `${IMAGE_S3_BASE_PATH}/logo-zapier.png`;
export const ZENDESK_LOGO = `${IMAGE_S3_BASE_PATH}/logo-zendesk.png`;
export const ZOHO_LOGO = `${IMAGE_S3_BASE_PATH}/logo-zoho-crm.png`;
export const DASHBOARD_IMAGE = `${IMAGE_S3_BASE_PATH}/dashboard_img.png`;
export const PDF_TEMPLATE_IMAGE = `${IMAGE_S3_BASE_PATH}/PublishPDFTemplate.png`;
export const BULK_ESIGN = `${IMAGE_S3_BASE_PATH}/BulkEsignSuccess.png`;
export const BULK_ESIGN_LZ = `${IMAGE_S3_BASE_PATH_LZ}/recipient-accept.png`;
export const CREATE_DOC_PNG = `${IMAGE_S3_BASE_PATH}/TT-create-doc-template.png`;
export const BULK_SEND_PNG = `${IMAGE_S3_BASE_PATH}/TT-Bulk-send-csv-template.png`;
export const INBOX_EMPTY_IMAGE_SRC = `${IMAGE_S3_BASE_PATH}/inbox-Zero.pn`;
export const blockEspace = `${IMAGE_S3_BASE_PATH}/block-ESpace.png`;
export const blockGSheet = `${IMAGE_S3_BASE_PATH}/block-GSheet.png`;
export const blockImage = `${IMAGE_S3_BASE_PATH}/block-image.png`;
export const blockPBreak = `${IMAGE_S3_BASE_PATH}/block-PBreak.png`;
export const blockQTable = `${IMAGE_S3_BASE_PATH}/block-QTable.png`;
export const blockSign = `${IMAGE_S3_BASE_PATH}/block-Sign.png`;
export const blockStripe = `${IMAGE_S3_BASE_PATH}/block-Stripe.png`;
export const blockTable = `${IMAGE_S3_BASE_PATH}/block-table.png`;
export const blockText = `${IMAGE_S3_BASE_PATH}/block-text.png`;
export const blockPageNumber = `${IMAGE_S3_BASE_PATH}/block-page-number.png`;
export const emptySigner = `${IMAGE_S3_BASE_PATH}/empty-fields.png`;
export const catInsideMailbox = `${IMAGE_S3_BASE_PATH}/cat-inside-mailbox.png`;
export const revvStamp = `${IMAGE_S3_BASE_PATH}/revvstamp.png`;
export const boxAdminConnect = `${IMAGE_S3_BASE_PATH}/box-admin-connect.png`;
export const integrationNotFound = `${IMAGE_S3_BASE_PATH}/integration_not_found.png`;
export const CSV_EMPTY_IMAGE = `${IMAGE_S3_BASE_PATH}/CSV-Empty-Image.png`;
export const PAYMENT_FAILED = `${IMAGE_S3_BASE_PATH}/payment_failed.png`;
export const LZ_ERROR_IMAGE = `${IMAGE_S3_BASE_PATH_LZ}/something-went-wrong.png`;
// .jpg files
export const FORM_TEMPLATE_IMAGE = `${IMAGE_S3_BASE_PATH}/Form-Template.jpg`;
export const EDITABLE_TEMPLATE_IMAGE = `${IMAGE_S3_BASE_PATH}/Editor-Template.jpg`;
export const logoCSA = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-csa.jpg`;
export const logoSOC = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-SOC.jpg`;
export const logoISO = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-iso27001.jpg`;
export const logoPCI = `${IMAGE_S3_BASE_PATH}/certificate-logos/logo-PCI.jpg`;

export const SignatureFailed = "";

// .gif files
export const esignError = `${IMAGE_S3_BASE_PATH}/esign-error.gif`;
export const ESIGN_GIF_RESCALED = `${IMAGE_S3_BASE_PATH}/Esign-GIF-Rescaled.gif`;
export const UNFILLED_FORM_FILLED = `${IMAGE_S3_BASE_PATH}/unfilled-form-filled.gif`;
export const WORKFLOW_LANE_GIF = `${IMAGE_S3_BASE_PATH}/Workflow-GIF.gif`;
export const ONBOARDING_METALENS_TUTORIAL_GIF = `${IMAGE_S3_BASE_PATH}/Revv_Metalens_Revised_GIF.gif`;
export const ONBOARDING_ESIGN_TUTORIAL_GIF = `${IMAGE_S3_BASE_PATH}/revv-esign.gif`;
export const ONBOARDING_PAYMENT_TUTORIAL_GIF = `${IMAGE_S3_BASE_PATH}/payment.gif`;
export const ADD_DOC_CMP_HELP_GIF = `${IMAGE_S3_BASE_PATH}/add_doc_cmp_help.gif`;
export const emptyDocumentPlaceholder = `${IMAGE_S3_BASE_PATH}/empty-doc-placeholder.gif`;

// import { IMAGE_URLS } from "../../constants";

// favicon link on recipient side esign
export const FAVICON = `${IMAGE_S3_BASE_PATH_LZ_TEST}/fav-icon.png`;

const NORMAL_IMAGE_RENDERING_DETAILS = {
  isImageField: false,
  showImagePlaceholder: true, // for showing the image placeholder
  showImageFieldPlaceholder: false, // for showing the image field placeholder
  showImageFieldHighlight: false, // for showing the image field highlight(green and yellow)
  allowActiveOnClick: false,
  showJustifyButtons: false,
};

const IMAGE_FIELD_RENDERING_DETAILS = {
  isImageField: true,
  showImagePlaceholder: false,
  showImageFieldPlaceholder: true,
  showImageFieldLabel: true,
  showImageFieldHighlight: true,
  allowActiveOnClick: false,
  allowResize: false,
  showJustifyButtons: false,
  allowImageFieldUpdate: false,
  getDefaultValue: false,
  getFieldValue: false,
};

export const IMAGE_RENDERING_DETAILS = {
  DOCUMENT: {
    EDITOR_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
        allowActiveOnClick: true,
        showJustifyButtons: true,
      },
      IMAGE_FIELD: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
        allowResize: true,
        isImageField: true,
        allowActiveOnClick: true,
        allowImageFieldUpdate: false,
        // getDefaultValue: true,
        getFieldValue: true,
        showJustifyButtons: true,
      },
    },
    FORM_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        allowResize: true,
        allowActiveOnClick: true,
        getFieldValue: true,
        allowImageFieldUpdate: true,
        showJustifyButtons: true,
      },
    },
    FORM_PERMA_LINK_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        showImageFieldLabel: false,
        showImageFieldHighlight: false,
        showImageFieldPlaceholder: false,
        getFieldValue: true,
      },
    },
    EDITOR_PERMA_LINK_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        showImageFieldLabel: false,
        showImageFieldHighlight: false,
        showImageFieldPlaceholder: false,
        // getDefaultValue: true,
        getFieldValue: true,
      },
    },
  },
  TEMPLATE: {
    EDITOR_MODE: {
      NORMAL_IMAGE: {
        ...NORMAL_IMAGE_RENDERING_DETAILS,
        allowActiveOnClick: true,
        showJustifyButtons: true,
      },
      IMAGE_FIELD: {
        ...IMAGE_FIELD_RENDERING_DETAILS,
        allowActiveOnClick: true,
        getDefaultValue: true,
      },
    },
  },
};

// Environment Names
const PRODUCTION = "PRODUCTION";
const TEST_ENV = "TEST_ENV";
const MOJITO = "MOJITO";
const MOJITO_REPLICA = "MOJITO_REPLICA";
const REVV_LZ_DEV = "REVV_LZ_DEV";
const REVV_LZ_QA = "REVV_LZ_QA";

// Domain name in which Website runs
export const REVV_LOGO_URL = {
  [PRODUCTION]:
    "https://d34fwl795uvawg.cloudfront.net/images/logo/revv-logo-color.png",
  // Mojito we are using for prod url testing temporary
  [MOJITO]:
    "https://d34fwl795uvawg.cloudfront.net/images/logo/revv-logo-color.png",
  [TEST_ENV]:
    "https://d34fwl795uvawg.cloudfront.net/preprod-images/revv-logo-color.png",
};
export const REVV_LOGO_URL_LZ = {
  [PRODUCTION]: `${IMAGE_S3_BASE_PATH_LZ}/logo-large.png`,
  // Mojito we are using for prod url testing temporary
  [MOJITO]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-large.png`,
  [MOJITO_REPLICA]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-large.png`,
  [REVV_LZ_DEV]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-large.png`,
  [REVV_LZ_QA]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-large.png`,
  [TEST_ENV]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-large.png`,
};

export const REVV_LOGO_URL_LZ_MOBILE = {
  [PRODUCTION]: `${IMAGE_S3_BASE_PATH_LZ}/logo-small.png`,
  // Mojito we are using for prod url testing temporary
  [MOJITO]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-small.png`,
  [MOJITO_REPLICA]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-small.png`,
  [REVV_LZ_DEV]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-small.png`,
  [REVV_LZ_QA]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-small.png`,
  [TEST_ENV]: `${IMAGE_S3_BASE_PATH_LZ_TEST}/logo-small.png`,
};

export const REVV_LOGO = {
  DATA_STUDIO: {
    STYLE: {
      height: "30px",
      width: "160px",
    },
  },
  RECIPIENT_HEADER: {
    STYLE: {
      height: "40px",
      width: "126px",
    },
    STYLE_MOBILE: {
      height: "26px",
      width: "26px",
    },
  },
  RECIPIENT_THANKYOU_POPUP: {
    STYLE: {
      height: "30px",
      width: "160px",
    },
  },
};
